import { createSelector } from 'reselect';

import { selectFactory } from '../../helpers';

import { STORE_NAME } from '../constants';

const selectInsurance = ({ [STORE_NAME]: result }) => {
  return result;
};

export const selectFields = selectFactory({ selector: selectInsurance });

export const collectValueFields = ({ field, selector }) => {
  return createSelector(selector, (values) => {
    return Object.entries(values).reduce((acc, [key, { [field]: value }]) => {
      acc[key] = value;

      return acc;
    }, {});
  });
};

export const selectFromCollect = ({ selector }) => {
  return (field) => {
    return createSelector(selector, ({ [field]: result }) => {
      return result;
    });
  };
};
